
import { Options, Vue } from 'vue-class-component';
import LoadingScreen from '@/components/LoadingScreen.vue';
// import LoadingScreen from '../LoadingScreen.vue';

@Options({
  components: {
    LoadingScreen
  }
})
export default class MLoading extends Vue {}
